import { createTriggerResource } from '@magicdoorinc/ui';
import { createMagicDoorContext } from '~/contexts/utils';
import { DepositSlipsRepository } from '~/repositories/depositSlipsRepository';
import type { DepositSlipCandidatesFilter, DepositSlipsFilter } from '~/repositories/depositSlipsRepository';
import type { CreateDepositSlipRequestDto, UpdateDepositSlipDto } from '~/swagger/accounting/Api';

const repo = new DepositSlipsRepository();
export const [DepositSlipsProvider, useDepositSlips] = createMagicDoorContext('DepositSlips', () => {
  const [filtered, setFilter, actions] = createTriggerResource((filter?: DepositSlipsFilter) => repo.getDepositSlips(filter));

  const addDepositSlip = async (payload: CreateDepositSlipRequestDto) => {
    await repo.addDepositSlip(payload);
  };

  const updateDepositSlip = async (depositSlipId: string, payload: UpdateDepositSlipDto) => {
    await repo.updateDepositSlip(depositSlipId, payload);
  };

  const getDepositSlipCandidates = async (filter: DepositSlipCandidatesFilter) => {
    return await repo.getDepositSlipCandidates(filter);
  };

  const getDepositSlip = async (depositSlipId: string) => {
    return await repo.getDepositSlip(depositSlipId);
  };

  const deleteDepositSlip = async (depositSlipId: string) => {
    await repo.deleteDepositSlip(depositSlipId);
  };

  return {
    filtered: filtered,
    setFilter: (filter: DepositSlipsFilter) => setFilter(filter),
    refetch: actions.refetch,
    addDepositSlip,
    getDepositSlipCandidates,
    getDepositSlip,
    updateDepositSlip,
    deleteDepositSlip,
  };
});
